import { Route, Routes } from 'react-router-dom'
import AppLayout from './AppLayout'
import LoginPage from './pages/LoginPage'
import ProfilePage from './pages/ProfilePage'
import AppRedirect from './pages/AppRedirect'
import BoatDetailsPage from './pages/BoatDetailsPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppLayout />} path="/">
        <Route element={<AppRedirect />} path="/" />
        <Route element={<LoginPage />} path="/login" />
        <Route element={<ProfilePage />} path="/profile" />
        <Route element={<BoatDetailsPage />} path="/boats/:boatId" />
      </Route>
    </Routes>
  )
}
